// Limite de registros para exibir alerta de resultado grande nas pesquisas
export const LIMITE_REGISTROS_PESQUISA = 2000


/*
export default {
    configapp: {
        baseURL: 'http://192.168.0.25:3001/',
        loginURL: 'http://192.168.0.25:8082/#/pages/login',
        atualizando: false
    }
}
*/


/* LOCALHOST */
/*
export default {
    configapp: {
        baseURL: 'http://localhost:3001/',
        loginURL: 'http://localhost:8082/#/pages/login',
        atualizando: false
    }
}
*/

/* BRASILIA*/
/*
export default {
    configapp: {
        baseURL: 'https://frigoracabsb.com.br:3001/',
        loginURL: 'https://frigoracabsb.com.br:8082/#/pages/login',
        atualizando: false
    }
}
*/

/* FEITOSA DIST*/
/*
export default {
    configapp: {
        baseURL: 'http://192.168.1.200:3002/',
        loginURL: 'http://192.168.1.200:8082/#/pages/login',
        atualizando: false
    }
}
*/

/* FEITOSA FIL*/

export default {
    configapp: {
        baseURL: 'https://frigorificofeitosa.com.br:3001/',
        loginURL: 'https://frigorificofeitosa.com.br:8082/#/pages/login',
        atualizando: false
    }
}

/* AMAFRIGO */
/*
export default {
    configapp: {
        baseURL: 'http://srv-sistema:3001/',
        loginURL: 'http://srv-sistema:3001/#/pages/login',
        atualizando: false
    }
}
*/

/* MIMO LOCAL */
/*
export default {
    configapp: {
        baseURL: 'http://servidormimo:3001/',
        loginURL: 'http://servidormimo:3001/#/pages/login',
        atualizando: false
    }
}
*/


/* 3A */
/*
export default {
    configapp: {
        baseURL: 'https://frigo3a.com.br:3001/',
        loginURL: 'https://frigo3a.com.br:3001/#/pages/login',
        atualizando: false
    }
}
**/
/* TESTE*/
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3004/',
        loginURL: 'http://localhost:8082/#/pages/login',
        atualizando: false
    }/*
}
*/

/* FRICARNES */
/*
export default {
    configapp: {
        baseURL: 'https://frigorificonorte.com.br:3001/',
        loginURL: 'https://frigorificonorte.com.br:3001/#/pages/login',
        atualizando: false
    }
}
*/
/*FfRIGORACA*/
/*
export default {
    configapp: {
        baseURL: 'https://bovinus.agr.br:3001/',
        loginURL: 'https://bovinus.agr.br:3001/#/pages/login',
        atualizando: false
    }
}
*/

/*SANTA MARIA*/
/*
export default {
    configapp: {
        baseURL: 'https://bovinus.agr.br:3003/',
        loginURL: 'https://bovinus.agr.br:3003/#/pages/login',
        atualizando: false
    }
}
*/

/* MIMO LOCAL */
/*
export default {
    configapp: {
        baseURL: 'http://servidormimo:3001/',
        loginURL: 'http://servidormimo:3001/#/pages/login',
        atualizando: false
    }
}
    */

/* Sitema Tech */
/*
export default {
    configapp: {
        baseURL: 'http://170.83.173.62:3033/',
        loginURL: 'http://170.83.173.62:3033/#/pages/login',
        atualizando: false
    }
}


/* escritorio */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3001/',
        loginURL: 'https://cecfrigo.com.br:3001/#/pages/login',
        atualizando: false
    }
}
*/
/* CASAS  */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3002/',
        loginURL: 'https://cecfrigo.com.br:3002/#/pages/login',
        atualizando: false
    }
}
*/

/* BASE 3  */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3003/',
        loginURL: 'https://cecfrigo.com.br:3003/#/pages/login',
        atualizando: false
    }
}
*/

/* brasileia */
/*;;;;
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3004/',
        loginURL: 'https://cecfrigo.com.br:3004/#/pages/login',
        atualizando: false
    }
}
*/
/* sena */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3005/',
        loginURL: 'https://cecfrigo.com.br:3005/#/pages/login',
        atualizando: false
    }
}
*/

/* cruzeiro */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3006/',
        loginURL: 'https://cecfrigo.com.br:3006/#/pages/login',
        atualizando: false
    }
}
*/
/* placido  */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3007/',
        loginURL: 'https://cecfrigo.com.br:3007/#/pages/login',
        atualizando: false
    }
}
*/

/* placido  */
/*
export default {
    configapp: {
        baseURL: 'https://cecfrigo.com.br:3008/',
        loginURL: 'https://cecfrigo.com.br:3008/#/pages/login',
        atualizando: false
    }
}
*/

/*
export default {
    configapp: {
        baseURL: 'http://localhost:3001/',
        loginURL: 'http://localhost:8082/#/pages/login',
        atualizando: false
    }
}
*/




//////////////////
// WEBPACK FOOTER
// ./static/parametros/parametros.js
// module id = 57
// module chunks = 2